var SCM = SCM || {};

SCM.ScholarlyiQ = (function ($) {

    return {
        init: _init
    };

    function _init() {
        if ($('.pg_searchresults').length) {
            trackSearchResultPageEvents();
        }
        trackAbstractClickEvents();
    }

    function trackOnPageEvent(ev) {
        var event = 'ev=' + encodeURIComponent(ev);
        ntptEventTag(event);
    }

    function trackAbstractClickEvents() {
        $(document).on('click', 'a.js-showChapterAbstractLink', function () {
            trackAbstractExtractClickEvent($(this));
        });
        $(document).on('click', 'a.showAbstractLink', function () {
            trackAbstractExtractClickEvent($(this));
        });
    }

    // NTPT_PGEXTRA is defined in the ScholaryIqPagTag widget and holds the extra dimension data we send to SIQ at page load
    function trackAbstractExtractClickEvent($clickedLink) {
        if (NTPT_PGEXTRA && abstractOpen($clickedLink)) {
            amendEventType('Investigation');
            updateAccessType($clickedLink);
            addAbstractContentId($clickedLink);
            addAbstractProductId($clickedLink);
            updateDataType($clickedLink);
            updateAccessMethod();
            ntptEventTag();
        }
    }

    function abstractOpen($clickedLink) {
        var ariaControlsAttr = $clickedLink.attr('aria-controls');
        var $abstractPlaceholder;
        if (ariaControlsAttr) {
            $abstractPlaceholder = $('.js-abstract-response-placeholder[id|=' + ariaControlsAttr + ']');
        } else {
            $abstractPlaceholder = $clickedLink.closest('.al-other-resource-links_wrap').find('.js-abstract-response-placeholder');
        }
        if ($abstractPlaceholder) {
            return !$abstractPlaceholder.hasClass('hide');
        } else {
            return false;
        }
    }

    function amendEventType(eventType) {
        if (NTPT_PGEXTRA.includes('event_type')) {
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/event_type=[^&]*/, 'event_type=' + eventType);
        } else {
            NTPT_PGEXTRA += '&event_type=' + eventType;
        }
    }

    function updateAccessType($clickedLink) {
        var accessType = getAccessType($clickedLink);
        if (NTPT_PGEXTRA.includes('access_type')) {
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/access_type=[^&]*/, 'access_type=' + accessType);
        }
        else {
            NTPT_PGEXTRA += '&access_type=' + accessType;
        }
    }

    function updateDataType($clickedLink) {
        var dataType = getDataType($clickedLink);
        if (!dataType) {
            return;
        }
        if (NTPT_PGEXTRA.includes('data_type')) {
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/data_type=[^&]*/, 'data_type=' + dataType);
        }
        else {
            NTPT_PGEXTRA += '&data_type=' + dataType;
        }
    }

    function getDataType($clickedLink) {
        if (isIssuePage()) {
            return 'Article';
        }
        if (isBookPage()) {
            return 'Book_Segment';
        }
        if (isSearchResultsPage()) {
            return getSearchResultDataType($clickedLink);
        }
        return '';
    }

    function getSearchResultDataType($clickedLink) {
        var $linkData = $clickedLink.closest('.al-article-box').find('.js-article-info,.js-book-info');
        if ($linkData.data('articleId') > 0) {
            return 'Article';
        }
        // Book TOC and Chapter pages are "Book_Segment"
        if ($linkData.data('bookId') > 0) {
            return 'Book_Segment';
        }
        return '';
    }

    function getAccessType($clickedLink) {
        var accessType = 'Controlled';
        var $accessIconParent;
        if (isSearchResultsPage()) {
            $accessIconParent = $clickedLink.closest('.sr-list.al-article-box');
        } else if (isIssuePage()) {
            $accessIconParent = $clickedLink.closest('.al-article-items');
        } else {
            $accessIconParent = $clickedLink.closest('li .sectiontype-Chapter');
        }
        if ($accessIconParent.length) {
            var $accessIcon = $accessIconParent.find('.icon-availability_open');
            if ($accessIcon.length) {
                accessType = 'OA_Gold';
            }
        }
        return accessType;
    }

    function addAbstractContentId($clickedLink) {
        var contentId = 0;
        var ariaControlsAttr = $clickedLink.attr('aria-controls');
        if (ariaControlsAttr) { 
            contentId = ariaControlsAttr.replace('abstract-', '');
        } else if (isSearchResultsPage()) {
            if (isBookRecord($clickedLink)) {
                contentId = $clickedLink.data('bookId');
            } else {
                contentId = $clickedLink.data('chapterSection');
            } 
        }
        if (NTPT_PGEXTRA.includes('item_id')) {
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/item_id=[^&]*/, 'item_id=' + contentId);
        } else {
            NTPT_PGEXTRA += '&item_id=' + contentId;
        }
    }

    function addAbstractProductId($clickedLink) {
        var productId = 0;
        if (isSearchResultsPage()) {
            var $articleInfo = $clickedLink.closest('.al-article-box').find('.js-article-info');
            if ($articleInfo.length) {
                productId = $articleInfo.data('journalId');
            } else {
                if (isBookRecord($clickedLink)) {
                    return;
                }
                var $bookInfo = $clickedLink.closest('.al-article-box').find('.js-book-info');
                if ($bookInfo.length) {
                    productId = $bookInfo.data('bookId');
                }
            }

        } else if (isIssuePage()) {
            productId = $('.issue-browse_content').data('journalid');
        } else {
            var $bookDataDiv = $clickedLink.closest('[data-bookid-for-abstract]');
            if ($bookDataDiv.length) {
                productId = $bookDataDiv.data('bookidForAbstract');
            }
        }
        NTPT_PGEXTRA += '&product_id=' + productId;
    }

    function isBookRecord($clickedLink) {
        var $type = $clickedLink.closest('.al-article-box').find('.article-type');
        if ($type) {
            return $type.text() === 'Book';
        }
        return false;
    }

    function updateAccessMethod() {
        if (NTPT_PGEXTRA.includes('access_method')) {
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/access_method=[^&]*/, 'access_method=Regular');
        }
        else {
            NTPT_PGEXTRA += '&access_method=Regular';
        }
    }

    function isIssuePage() {
        return $('.pg_Issue').length;
    }

    function isBookPage() {
        return $('.pg_Book').length;
    }

    function isSearchResultsPage() {
        return $('.pg_searchresults').length;
    }

    function trackSearchResultPageEvents() {
        $(document).on('click', '.js-result-link', function () {
            if (NTPT_PGEXTRA) {
                NTPT_PGEXTRA = NTPT_PGEXTRA.replace(/event_type=[^&]*/, 'event_type=Result_Click');
            }
            trackOnPageEvent('Result_Click');
        });
    }

})(jQuery);

